import { push } from 'connected-react-router';
import { connect } from 'react-redux';

import { getPreviousPathName } from 'src/app/state/selectors';
import type { RootState } from 'src/app/state/store';

import { PromoOnboardingWaitlistRenderer } from '.';

export const PromoOnboardingWaitlist = connect(
  (state: RootState) => ({
    previousPathName: getPreviousPathName(state),
  }),
  dispatch => ({
    dispatchRedirectToPreviousRouterLocation: previousPathName => dispatch(push(previousPathName)),
  })
)(PromoOnboardingWaitlistRenderer);
